import accordion from "./components/accordion";
import commentsMasonry from "./components/commentsMasonry";
import faqAccordion from "./components/faqAccordion";
import infiniteSvg from "./components/infiniteSvg";
import intersection from "./components/intersection";
import lockSlider from "./components/lockSlider";
import logosAjax from "./components/logosAjax";
import mapModals from "./components/mapModals";
import masonryAjax from "./components/masonryAjax";
import navigation from "./components/navigation";
import numbersCounter from "./components/numbersCounter";
import readMore from "./components/readMore";
import slider from "./components/slider";
import teamSearch from "./components/teamSearch";
import yearSlider from "./components/yearSlider";

const init = () => {
  navigation();
  slider();
  accordion();
  lockSlider();
  faqAccordion();
  mapModals();
  yearSlider();
  teamSearch();
  commentsMasonry();
  readMore();
  infiniteSvg();
  numbersCounter();
  intersection();
  masonryAjax();
  logosAjax();
};

init();
